// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { enablePostalCodeLocationFinder } from "@bg/App/Store/Selectors/PostalCodeSelector";
import { constants } from "@bg/XDL/constants";
import { hasLocalStorage } from "@bg/XDL/Utilities";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getProductCollectionRealTimePrices } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

export const XngRequestDataFromApi: any = async (props: any) => {
    if (
        enablePostalCodeLocationFinder(props.getState()) &&
        !hasLocalStorage(constants.localStorage.POSTAL_CODE_ID) &&
        !props.getState().context.session.isAuthenticated
    ) {
        return;
    }
    if (!getSettingsCollection(props.getState()).productSettings.canSeePrices) {
        return false;
    }

    try {
        props.apiResult = await getProductCollectionRealTimePrices(props.apiParameter);
    } catch (error) {
        if (error.status === 403) {
            // auth timed out with sign in required for pricing - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
            throw error;
        } else {
            logger.warn(`Failed to load pricing data: ${error}`);
            props.error = error;
        }
    }
};
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
